import Layout from '../../../components/Layout';
import Menu from '../../../components/Layout/Menu';

import InternationalCreateContent from '../../../components/Pages/Internationals/Create';

export default function PageCreate(): JSX.Element | null {
  document.title = `${process.env.REACT_APP_TITLE}: Create international page`;

  return (
    <Layout LeftMenu={Menu} transparent>
      <InternationalCreateContent />
    </Layout>
  );
}
